<h3>Monatsabschluß &amp; Datenexport</h3>
<span class="btn btn-primary" ng-click="vm.lastmonth()">Letztes Monat</span>


<h3>Datenexport für beliebige Zeiträume</h3>
<form class="form-vertical">
  <div class="row">
    <div class="col-md-6">
      <label for="startdate">Von</label>

      <p class="input-group">
        <input type="text" class="form-control" uib-datepicker-popup="yyyy-MM-dd" ng-model="vm.startdate"
               is-open="start.opened" ng-required="true" id="startdate" name="startdate"
               clear-text="Löschen" close-text="Schließen" current-text="Heute" starting-day="1"
               alt-input-formats="vm.altInputFormats"/>
              <span class="input-group-btn">
                <button type="button" class="btn btn-default" ng-click="start.opened = true;"><i
                  class="fa fa-calendar"></i></button>
              </span>
      </p>
    </div>
    <div class="col-md-6">
      <label for="enddate">Bis</label>
      <p class="input-group">
        <input type="text" class="form-control" uib-datepicker-popup="yyyy-MM-dd" ng-model="vm.enddate"
               is-open="end.opened" ng-required="true" id="enddate" name="enddate"
               close-text="Schließen" clear-text="Löschen" current-text="Heute" starting-day="1"
               alt-input-formats="vm.altInputFormats"/>
              <span class="input-group-btn">
                <button type="button" class="btn btn-default" ng-click="end.opened = true;"><i
                  class="fa fa-calendar"></i></button>
              </span>
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <button class="btn btn-success" ng-click="vm.freeinterval()"><i class="fa fa-download"></i> Exportieren</button>
    </div>
  </div>
</form>
